import React, { Component } from 'react';
import AlertLevel from '../../../../shared/alert-level/AlertLevel';
import PlayerIdAndName from '../../../../shared/player-id-and-name/PlayerIdAndName';

class TopRiskyPlayers extends Component {
    eventsTableHeaders = ['Player Id', 'Name', 'Country', 'Overall Risk'];

    render() {
        return (
            <div className="table">
                <table>
                    <tbody>
                        <tr className="headers">
                            {this.eventsTableHeaders.map((header, i) => (
                                <td key={i}>{header}</td>
                            ))}
                        </tr>
                        {this.props.riskyPlayers.map(player => (
                            <tr className="data" key={player.id}>
                                <td>
                                    <PlayerIdAndName
                                        id={player.id}
                                        username={player.username}
                                    />
                                </td>
                                <td>
                                    {player.name} {player.surname}
                                </td>
                                <td>{player.country}</td>
                                <td>
                                    <AlertLevel level={player.riskLevel} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default TopRiskyPlayers;
